module.exports = __webpack_public_path__ + "assets/img/share.6aa6f630.png";